import type React from 'react';
import { ImageBox } from '../ImageBox';
import { ImageDetails } from '../ImageDetails';
import { ImageInputBox, type ImageInputBoxProps } from './ImageInputBox';

export interface SelectedImageProps
  extends Pick<ImageInputBoxProps, 'autoFocus' | 'disableFocus' | 'onFocus'> {
  url: string;
  onClick?: () => void;
  children: React.ReactNode;
  autoFocus?: boolean;
  disableFocus?: boolean;
}

export const SelectedImage = ({
  url,
  onClick,
  children,
  autoFocus,
  disableFocus,
  onFocus,
}: SelectedImageProps) => {
  return (
    <ImageInputBox
      autoFocus={autoFocus}
      onClick={onClick}
      disableFocus={disableFocus}
      onFocus={onFocus}
    >
      <div className="w-full flex gap-4">
        <div className="shrink-0">
          <ImageBox url={url} />
        </div>
        <ImageDetails>{children}</ImageDetails>
      </div>
    </ImageInputBox>
  );
};

SelectedImage.ImageName = ImageDetails.Name;
SelectedImage.ImageMetadata = ImageDetails.Metadata;
